module.exports = __webpack_public_path__ + "media/app3.b1820d0b.mp4";